/** Public support contact for the trial. */
export const SUPPORT_EMAIL = 'support@anterotrail.com';
